var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeco11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 673,
    height: 665,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-117 -2172)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.508 2415.78 309.716 2412.57 243.827 2249.14 394.461 2349.53 442.281 2180.14 501.801 2345.78 645.064 2235.13 590.736 2402.75 774.72 2393.1 627.295 2498.68 781.725 2593.72 597.517 2596.93 663.406 2760.36 512.772 2659.97 464.952 2829.35 405.432 2663.72 262.169 2774.37 316.497 2606.75 132.513 2616.39 279.938 2510.81Z",
    stroke: "#000000",
    strokeWidth: 4.58333,
    strokeMiterlimit: 8,
    fill: "#45B382",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeco11);
export default __webpack_public_path__ + "static/media/deco11.4d63503cfac9e86170c0a675f1b786a9.svg";
export { ForwardRef as ReactComponent };